import React, {useEffect, useRef, useState} from "react"

function FAQItem(props) {

    const pRef = useRef(null)
    const [open, setOpen] = useState(false)

    const handleClick = () => {
        setOpen(!open)
    }

    useEffect(() => {
        const element = pRef.current
        if (element && open) {
            element.style.height = '0'
            element.style.margin = '0'
            element.style.opacity = '0'
            requestAnimationFrame(() => {
                element.style.height = element.scrollHeight + "px"
                element.style.margin = "0 0 2rem 0"
                element.style.opacity = "100"
            })
        }
        if (element && !open) {
            requestAnimationFrame(() => {
                element.style.height = '0'
                element.style.margin = '0'
                element.style.opacity = '0'
            })
        }
    }, [open])

    return (
        <div className="faqitem" onClick={handleClick}>
            <h3 className="helpheading">{props.question}</h3>
            <p ref={pRef} className="faqanswer">{props.answer}</p>
        </div>
    )
}

export default FAQItem;